<div class="header">{{ modal.context.title }}</div>
<div class="content">
  <p>{{ modal.context.question }}</p>
</div>
<div class="actions">
  <button class="ui button" (click)="modal.deny(undefined)">Cancel</button>
  <button class="ui green button" (click)="modal.approve(undefined)" autofocus>OK</button>
</div>
